var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"emoji__item",attrs:{"title":_vm.emojiName},on:{"click":function($event){return _vm.$emit('click', {emoji: _vm.emoji, emojiName: _vm.emojiName})}}},[_vm._v(" "+_vm._s(_vm.emoji)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }